import { CRUD_Domains, CRUD_Price_table } from "../../hooks/APIHooks";
import React, { useEffect, useState } from "react";
import { useAuth } from "../../hooks/GlobalProvider";
import { useNavigate } from "react-router-dom";
import {
  FaGlobe,
  FaCalendarAlt,
  FaExclamationTriangle,
  FaMoneyBillWave,
  FaLayerGroup,
  FaUserCircle,
} from "react-icons/fa";
import NavbarAuth from "../../components/Navbar/Navbar_Auth";

function Renewal() {
  const { user } = useAuth();
  const [domains, setDomains] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [pricingOptions, setPricingOptions] = useState([]);
  const [selectedPlans, setSelectedPlans] = useState({});
  const navigate = useNavigate();

  useEffect(() => {
    const fetchDomains = async () => {
      try {
        const res = await fetch(`${CRUD_Domains}?customer_id=${user.id}`);
        const data = await res.json();
        if (data.error) {
          setError(data.error);
        } else {
          setDomains(data);
        }
      } catch (err) {
        console.error("Fetch error:", err);
        setError("Failed to fetch domain renewals");
      } finally {
        setLoading(false);
      }
    };

    const fetchPricingOptions = async () => {
      try {
        const res = await fetch(CRUD_Price_table);
        const data = await res.json();
        if (data.error) {
          setError(data.error);
        } else {
          setPricingOptions(data);
        }
      } catch (err) {
        console.error("Fetch error:", err);
        setError("Failed to fetch pricing options");
      }
    };

    if (user?.id) {
      fetchDomains();
      fetchPricingOptions();
    } else {
      setError("User ID is not available");
      setLoading(false);
    }
  }, [user]);

  const handlePlanChange = (domainId, priceInr) => {
    const selectedPlan = pricingOptions.find(option => option.price_inr === priceInr);
    setSelectedPlans(prev => ({ ...prev, [domainId]: selectedPlan }));
  };

  const handlePayNow = (domainId) => {
    const plan = selectedPlans[domainId];
    if (plan) {
      navigate('/dashboard/renewal/payment', {
        state: {
          domain: domains.find(d => d.id === domainId),
          amount: plan.price_inr,
        },
      });
    }
  };

  if (loading) {
    return (
      <div className="flex justify-center items-center min-h-screen text-gray-600">
        Loading domain renewals...
      </div>
    );
  }

  if (error) {
    return (
      <div className="text-red-600 text-center font-medium mt-10">{error}</div>
    );
  }

  return (
    <div><NavbarAuth/>
    <div className="p-6  mx-auto ">
    
      <div className="text-center mb-8">
        <h1 className="text-4xl font-bold text-primary mb-2">Domain Renewals</h1>
       
      </div>

      {domains.length > 0 ? (
        <div className="space-y-6">
          {domains.map((domain) => {
            const expiryDate = new Date(domain.expiry_date);
            const isExpired = expiryDate < new Date();
            const selectedPlan = selectedPlans[domain.id];

            return (
              <div
                key={domain.id}
                className={`border-l-4 rounded-xl p-6 shadow-md transition ${
                  isExpired
                    ? "border-red-500 bg-gradient-to-r from-red-500 via-red-400 to-red-300 text-white"
                    : "bg-primary text-white"
                }`}
              >
                <div className="mb-4 flex items-center gap-2 text-xl font-semibold">
                  <FaGlobe />
                  {domain.user_domain}
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-3 text-sm">
                  <p className="flex items-center gap-2">
                    <FaUserCircle /> Name: {domain.user_name}
                  </p>
                  <p className="flex items-center gap-2">
                    <FaCalendarAlt /> Purchased: {domain.purchased_date}
                  </p>
                  <p className="flex items-center gap-2">
                    <FaCalendarAlt /> Expiry: {domain.expiry_date}
                  </p>
                  <p className="flex items-center gap-2">
                    <FaLayerGroup /> Tier: {domain.tier}
                  </p>
                </div>

                {isExpired && (
                  <div className="mt-4 space-y-3">
                    <p className="flex items-center gap-2 text-sm font-medium">
                      <FaExclamationTriangle className="text-white" />
                      This domain has expired. Please renew.
                    </p>

                    <div>
                      <label className="block mb-1 font-semibold">Choose Plan</label>
                      <select
                        value={selectedPlan?.price_inr || ""}
                        onChange={(e) => handlePlanChange(domain.id, e.target.value)}
                        className="w-full md:w-auto px-4 py-2 rounded-md text-black bg-white shadow"
                      >
                        <option value="" disabled>Select Plan</option>
                        {pricingOptions.map((option) => (
                          <option key={option.id} value={option.price_inr}>
                            {option.duration_label}
                          </option>
                        ))}
                      </select>
                    </div>

                    {selectedPlan && (
                      <div className="text-sm text-white space-y-1">
                        <p><strong>Duration:</strong> {selectedPlan.duration_days} days</p>
                        <p><strong>Price:</strong> ₹{selectedPlan.price_inr}</p>
                      </div>
                    )}

                    {selectedPlan && (
                      <button
                        onClick={() => handlePayNow(domain.id)}
                        className="flex items-center gap-2 bg-white text-red-600 font-semibold px-5 py-2 rounded-full hover:bg-gray-100 shadow-md"
                      >
                        <FaMoneyBillWave /> Pay Now ₹{selectedPlan.price_inr}
                      </button>
                    )}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      ) : (
        <div className="text-center text-gray-600 text-lg mt-10">
          No domain renewals found.
        </div>
      )}
    </div></div>
  );
}

export default Renewal;
